import { useState, useEffect } from "react";
import {
  getTenantDashboardData,
  updateTenantProfileData,
} from "../../../services/tenant/tenantServices";
import { useAuth } from "../../../context/AuthContext";

export default function TenantDashboard() {
  const { user } = useAuth();
  const [isDashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    fetchDashboardDetail();
  }, []);

  const fetchDashboardDetail = async () => {
    try {
      const res = await getTenantDashboardData();
      if (res?.statusCode === 1) {
        setDashboardData(res?.data);
      }
    } catch (err) {
      console.log(
        err.response?.data?.message || "Failed to fetch dashboard Report Data",
        "error",
      );
    }
  };

  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              My Dashboard
            </div>
            <div className="page-sub" id="page-sub">
              Welcome , {user?.fullName}
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div
            style={{
              background: "linear-gradient(135deg,#633806,#BA7517)",
              borderRadius: "var(--radius-md)",
              padding: "14px 20px",
              marginBottom: 16,
              display: "flex",
              alignItems: "center",
              gap: 14,
            }}
          >
            <span style={{ fontSize: 20 }}>🪙</span>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 10,
                  color: "rgba(255,255,255,0.7)",
                  textTransform: "uppercase",
                  letterSpacing: ".07em",
                }}
              >
                Coin Balance
              </div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#fff" }}>
                {isDashboardData?.coinBalance}
              </div>
            </div>
            <button
              onclick="openAddCoinModal('tenant')"
              style={{
                background: "rgba(255,255,255,0.2)",
                border: "1px solid rgba(255,255,255,0.35)",
                color: "#fff",
                borderRadius: "var(--radius-md)",
                padding: "6px 14px",
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              + Add Coins
            </button>
          </div>
          <div className="stat-grid">
            <div className="stat-card">
              <div className="stat-icon">🏠</div>
              <div className="stat-label">My Room</div>
              <div className="stat-value">{isDashboardData?.propertyInfo}</div>
              <div className="stat-delta delta-neu">
                {isDashboardData?.societyName}
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-label">Rent Due</div>
              <div className="stat-value">
                ₹ {isDashboardData?.pendingDueAmount}
              </div>
              <div className="stat-delta delta-dn">
                {isDashboardData?.dueMonth} 2025
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">KYC</div>
              <div className="stat-value"> {isDashboardData?.kycStatus}</div>
              <div className="stat-delta delta-up">Aadhaar + PAN</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📄</div>
              <div className="stat-label">Agreement</div>
              <div className="stat-value">
                {isDashboardData?.agreementStatus}
              </div>
              <div className="stat-delta delta-up">
                Till {isDashboardData?.agreementEndLabel}
              </div>
            </div>
          </div>
          <div className="card mt8">
            <button
              className="btn btn-primary"
              style={{ width: "100%" }}
              onclick="showPage('tn-payments',document.querySelector('[data-id=tn-payments]'))"
            >
              💳 Pay April Rent — ₹ {isDashboardData?.pendingDueAmount}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
